/**
 * Fix scrolling to bottom of viewport on Captcha reload
 *
 * @param {}
 * @return {void}
 */

const $challengeContainer = $('.shopify-challenge__container');

if ($challengeContainer.length !== 0) {
  $('html, body').animate({
    scrollTop: 0
  }, 800);
}
